// Re-export all common components from a single entry point

// Button component
export * from './Button';

// Card components
export * from './Card';

// Typography components
export * from './Typography';

// Form components
export * from './Input';
export * from './Select';

// Feedback components
export * from './Badge';
export * from './Modal';

// Layout components
export * from './layout/Layout';

// Export a default object with all components for easy access
export default {
  // Button variants
  Button: require('./Button').Button,
  Primary: require('./Button').Primary,
  Secondary: require('./Button').Secondary,
  Outline: require('./Button').Outline,
  Ghost: require('./Button').Ghost,
  Danger: require('./Button').Danger,
  Success: require('./Button').Success,

  // Card components
  Card: require('./Card').Card,
  CardHeader: require('./Card').CardHeader,
  CardTitle: require('./Card').CardTitle,
  CardDescription: require('./Card').CardDescription,
  CardContent: require('./Card').CardContent,
  CardFooter: require('./Card').CardFooter,
  
  // Typography components
  Heading: require('./Typography').Heading,
  H1: require('./Typography').H1,
  H2: require('./Typography').H2,
  H3: require('./Typography').H3,
  H4: require('./Typography').H4,
  H5: require('./Typography').H5,
  H6: require('./Typography').H6,
  Text: require('./Typography').Text,
  Lead: require('./Typography').Lead,
  Muted: require('./Typography').Muted,
  Small: require('./Typography').Small,
  Link: require('./Typography').Link,
  
  // Form components
  Input: require('./Input').Input,
  TextField: require('./Input').TextField,
  Select: require('./Select').Select,
  
  // Feedback components
  Badge: require('./Badge').Badge,
  Modal: require('./Modal').Modal,
  SmallModal: require('./Modal').SmallModal,
  MediumModal: require('./Modal').MediumModal,
  LargeModal: require('./Modal').LargeModal,
  ExtraLargeModal: require('./Modal').ExtraLargeModal,
  ModalContent: require('./Modal').ModalContent,
  ModalFooter: require('./Modal').ModalFooter,
  
  // Layout components
  Container: require('./Layout').Container,
  Stack: require('./Layout').Stack,
  Grid: require('./Layout').Grid,
  Flex: require('./Layout').Flex,
  Divider: require('./Layout').Divider,
};
